var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bug-report"},[_c('span',{staticClass:"text"},[_vm._v("משהו נראה לא נכון?")]),_vm._v(" "),_c('span',{staticClass:"link",on:{"click":function($event){return _vm.action()}}},[_vm._v("דווחו כאן על תקלה")])])}
var staticRenderFns = []

export { render, staticRenderFns }